(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
document.addEventListener('DOMContentLoaded',()=>{
  if(window.innerWidth>768) return; // mobile only
  const blocks=document.querySelectorAll('.footer__block');
  blocks.forEach(block=>{
    const title=block.querySelector('.h6');
    const content=block.querySelector('.footer-collapsible');
    if(title && content){
      title.classList.add('footer-toggle');
      content.classList.remove('open');
      title.addEventListener('click',()=>{
        const willOpen=!title.classList.contains('open');

        // close others
        blocks.forEach(b=>{
          if(b!==block){
            const t=b.querySelector('.footer-toggle');
            const c=b.querySelector('.footer-collapsible');
            if(t) t.classList.remove('open');
            if(c) c.classList.remove('open');
          }
        });

        // toggle this one
        title.classList.toggle('open', willOpen);
        content.classList.toggle('open', willOpen);
      });
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
